import React, { Component } from 'react';
import FroalaEditorComponent from 'react-froala-wysiwyg';
import 'froala-editor/js/plugins/align.min.js';
import 'froala-editor/js/plugins/colors.min.js';
import 'froala-editor/js/plugins/font_size.min.js';
import 'froala-editor/js/plugins/image.min.js';
import 'froala-editor/js/plugins/table.min.js';
import 'froala-editor/js/plugins/fullscreen.min.js';
import 'froala-editor/js/plugins/lists.min.js';
import 'froala-editor/js/plugins/code_view.min.js';
import 'froala-editor/js/plugins/link.min.js';
import 'froala-editor/js/plugins/paragraph_format.min.js';
import style from './style/editabletext.scss';

export default class EditableText extends Component {
    constructor(props) {
        super();

        this.generalSaveInterval = 5000;

        this.state = {
            newTextField: true,
            waitingForCreation: false,
            editMode: false,
            textEditable: props.textEditable || false,
            text: props.text || '',
            cursorInserted: false
        };
    }

    componentWillUnmount() {
        this.clearSaveInterval();
    }

    componentDidMount() {
        this.setState({ textEditable: this.props.textEditable });

        this.setTextElement();

        this.lastSavedText = this.state.text;
        this.isBeingCreated = false;
        this.createdSlug = null;
    }

    setSaveInterval() {
        const intervalTimeout = this.props.saveInterval || this.generalSaveInterval;

        this.timeout = window.setTimeout(() => {
            this.saveInterval = window.setInterval(() => {
                this.saveReportText();
            }, intervalTimeout);
        }, 1000);
    }

    clearSaveInterval() {
        if (this.timeout) {
            window.clearTimeout(this.timeout);
            this.timeout = null;
            delete this.timeout;
        }

        if (this.saveInterval) {
            window.clearInterval(this.saveInterval);
            this.saveInterval = null;
            delete this.saveInterval;
        }
    }

    saveReportText() {
        if (this.lastSavedText === this.state.text) {
            return;
        }

        const slugToPost = this.props.slug || this.createdSlug || null;

        if (!slugToPost && this.isBeingCreated) {
            return;
        }

        this.lastSavedText = this.state.text;

        this.isBeingCreated = !slugToPost;

        this.props.saveReportText({
            slug: slugToPost,
            templateSlug: this.props.templateSlug,
            name: this.props.name,
            value: this.state.text
        }, false).then(response => {
            if (response && response.slug) {
                this.createdSlug = response.slug;
            }

            this.isBeingCreated = false;

        }).catch(() => {
            this.isBeingCreated = false;
        });
    }

    setTextElement(text = this.state.text) {
        if (this.props.id) {
            if (document.querySelector(`#${this.props.id}`)) {
                document.querySelector(`#${this.props.id}`).innerHTML = text || this.props.textareaPlaceholderText;
            }
        } else {
            if (document.querySelector(`#reflection-${this.props.slug}`)) {
                document.querySelector(`#reflection-${this.props.slug}`).innerHTML = text || this.props.textareaPlaceholderText;
            }
        }
    }

    switchEditor() {
        if (this.state.textEditable && !this.props.isFinalized) {
            if (this.state.editMode) {
                this.setState({ editMode: false }, () => {
                    this.clearSaveInterval();
                    this.saveReportText();
                    this.setTextElement(this.state.text);
                });
            } else {
                this.setState({ editMode: true }, () => {
                    this.setSaveInterval();

                    // since Froala's own focus event did not seem to work (probably async issue) focus the editor after a short delay
                    setTimeout(() => {
                        const editorInstance = document.querySelector('.fr-element');
                        if (editorInstance) {
                            editorInstance.focus();
                        }
                    }, 500);
                });
            }
        }
    }

    handleTextChange(text) {
        this.setState({ text });
    }

    getFieldId() {
        if (this.props.id) {
            return `${this.props.id}`;
        }

        return `reflection-${this.props.slug}`
    }

    render() {
        const { allowedToEditReflection } = this.props;

        if (this.state.editMode) {
            return (<FroalaEditorComponent
                attribution={false}
                config={{
                    attribution: false,
                    editorClass: style.editableText,
                    htmlAllowedTags: ['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'li', 'ul', 'ol', 'br', 'strong', 'em', 'i', 'u'],
                    pastePlain: true,
                    spellcheck: true,
                    toolbarSticky: false,
                    listAdvancedTypes: false,
                    key: process.env.FROALA_KEY,
                    toolbarButtons: [
                        'paragraphFormat',
                        'formatOL',
                        'formatUL',
                        'bold',
                        'italic',
                        'underline',
                        '|',
                        'undo',
                        'redo',
                    ],
                    paragraphFormat: {
                        N: 'Normal',
                        H4: 'Heading',
                        H5: 'Subheading',
                    },
                    paragraphFormatSelection: true,
                    events: {
                        blur: () => {
                            this.switchEditor();
                        },
                        initialized: (e, editor) => {
                            if (editor && editor.selection) {
                                editor.selection.save();
                                editor.selection.clear();
                                editor.selection.restore();
                            }

                            if (editor && editor.events) {
                                editor.events.focus();
                            }
                        }
                    },
                    placeholderText: this.props.textareaPlaceholderTextActive || ''
                }}
                model={this.state.text}
                tag="textarea"
                onModelChange={(text) => {
                    this.handleTextChange(text);
                }}
            />
            );
        }

        return (<div
            className={`${style.editableText} ${!this.state.text.replace(/ |<p>|<\/p>|<br>/g, '') ? style.empty : ''}`}
            id={this.getFieldId()}
            onClick={allowedToEditReflection ? this.switchEditor.bind(this) : null}
            role="textbox"
            tabIndex="0"
        />);
    }
}
